import i18n from 'i18next';

function normalizeLocale(language) {
  const locales = {
    'pt-BR': 'pt-BR',
    pt: 'pt-BR',
    es: 'es',
    en: 'en',
  };

  return locales[language];
}

export function updateLang(event) {
  if (!event.detail) {
    return;
  }

  const language = normalizeLocale(event.detail.language)
  i18n.changeLanguage(language);
  document.documentElement.setAttribute('lang', language);
}
